import { render } from "./StrikerApp.vue?vue&type=template&id=23cdcae7&scoped=true"
import script from "./StrikerApp.vue?vue&type=script&lang=js"
export * from "./StrikerApp.vue?vue&type=script&lang=js"

import "./StrikerApp.vue?vue&type=style&index=0&id=23cdcae7&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23cdcae7"]])

export default __exports__